import React from 'react'
import { Header } from 'components/Header'
import { Layout } from 'components/Layout'
import { LoginForm } from './components/LoginForm/LoginForm'
import { LoginLayout } from './components/LoginLayout'

type LoginProps = {
  isExistingEmail?: boolean
  forward?: string
}

export const Login = ({ isExistingEmail = false, forward }: LoginProps) => {
  const header = <Header />

  return (
    <Layout header={header} hideCTA>
      <LoginLayout>
        <LoginForm isExistingEmail={isExistingEmail} forward={forward} />
      </LoginLayout>
    </Layout>
  )
}
